import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackAppOpen, trackPageView } from '@/lib/analytics';

/**
 * Emits `app_open` (once per tab session) and `page_view` (per route change).
 * Renders nothing; must live inside the Router.
 */
export function RouteTracker() {
  const { pathname } = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    // StrictMode mounts effects twice in dev — don't double-count the same route.
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;

    void trackAppOpen(pathname);
    void trackPageView(pathname);
  }, [pathname]);

  return null;
}
